import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

const currentDomain = window.location.hostname;
const validDomains = ["localhost", "vudio", "vyumi", "getepik"];
const isVudioDomain = validDomains.some((domain) =>
  currentDomain.includes(domain)
);

export const publicRoutes = isVudioDomain
  ? [
      {
        key: "login",
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() =>
          import("views/app-views/vudio/auth-views/authentication/Layout")
        ),
      },
      {
        key: "loginInfluencer",
        path: `${AUTH_PREFIX_PATH}/login/influencer`,
        component: React.lazy(() =>
          import(
            "views/app-views/vudio/auth-views/authentication/Login/Influencer"
          )
        ),
      },
      {
        key: "register",
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() =>
          import("views/app-views/vudio/auth-views/authentication/Layout")
        ),
      },
      {
        key: "forgotPassowrd",
        path: `${AUTH_PREFIX_PATH}/forgotPassword`,
        component: React.lazy(() =>
          import("views/app-views/vudio/auth-views/authentication/Layout")
        ),
      },
      {
        key: "passwordReset",
        path: `${AUTH_PREFIX_PATH}/passwordReset`,
        component: React.lazy(() =>
          import("views/app-views/vudio/auth-views/authentication/Layout")
        ),
      },
      {
        key: "registerInfluencer",
        path: `${AUTH_PREFIX_PATH}/register/influencer`,
        component: React.lazy(() =>
          import(
            "views/app-views/vudio/auth-views/authentication/Signup/Influencer"
          )
        ),
      },

      {
        key: "signUpWithGoogle",
        path: `${AUTH_PREFIX_PATH}/signUpWithGoogle`,
        component: React.lazy(() =>
          import("views/app-views/vudio/auth-views/authentication/Layout")
        ),
      },

       {
        key: "emailVerification",
        path: `${AUTH_PREFIX_PATH}/emailVerification`,
        component: React.lazy(() =>
          import(
            "views/app-views/vudio/auth-views/authentication/Layout"
          )
        ),
      },

      {
        key: "sso-auth",
        path: `${AUTH_PREFIX_PATH}/sso`,
        component: React.lazy(() =>
          import("views/auth-views/authentication/sso")
        ),
      },
      {
        key: "influencer-acceptions",
        path: `${AUTH_PREFIX_PATH}/influencer`,
        component: React.lazy(() =>
          import("views/auth-views/authentication/influencer-invitation")
        ),
      },
      {
        key: "aggregator-acceptions",
        path: `${AUTH_PREFIX_PATH}/aggregator`,
        component: React.lazy(() =>
          import("views/auth-views/authentication/influencer-invitation")
        ),
      },
      {
        key: "amazon-acceptions",
        path: `${AUTH_PREFIX_PATH}/amazon`,
        component: React.lazy(() =>
          import("views/auth-views/authentication/influencer-invitation")
        ),
      },
    ]
  : [
      {
        key: "login",
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() =>
          import("views/auth-views/authentication/login")
        ),
      },
      {
        key: "resetPassword",
        path: `${AUTH_PREFIX_PATH}/passwordReset`,
        component: React.lazy(() =>
          import("views/auth-views/authentication/reset-password")
        ),
      },
      {
        key: "register",
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() =>
          import("views/auth-views/authentication/register")
        ),
      },
      {
        key: "forgot-password",
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() =>
          import("views/auth-views/authentication/forgot-password")
        ),
      },
      {
        key: "sso-auth",
        path: `${AUTH_PREFIX_PATH}/sso`,
        component: React.lazy(() =>
          import("views/auth-views/authentication/sso")
        ),
      },
      {
        key: "influencer-acceptions",
        path: `${AUTH_PREFIX_PATH}/influencer`,
        component: React.lazy(() =>
          import("views/auth-views/authentication/influencer-invitation")
        ),
      },
      {
        key: "aggregator-acceptions",
        path: `${AUTH_PREFIX_PATH}/aggregator`,
        component: React.lazy(() =>
          import("views/auth-views/authentication/influencer-invitation")
        ),
      },
    ];

const vudio_routes = [
  {
    key: "dashboard.default",
    title: "Home",
    path: `${APP_PREFIX_PATH}/dashboards/default`,
    component: React.lazy(() =>
      import("views/app-views/vudio/vudio-home-page/MainVudioHomepage")
    ),
  },
  {
    key: "dashboard.socialMedia",
    title: "Social Media",
    path: `${APP_PREFIX_PATH}/dashboards/socialMedia`,
    component: React.lazy(() => import("views/app-views/vudio/dashboard")),
  },
  {
    key: "dashboard.socialMedia.autoPost",
    title: "Social Media",
    path: `${APP_PREFIX_PATH}/dashboards/socialMedia/autoPost`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/BatchMode/BatchModeHome")
    ),
  },
  {
    key: "dashboard.socialMedia.autoPostCreate",
    title: "Social Media",
    path: `${APP_PREFIX_PATH}/dashboards/socialMedia/autoPost/create`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/BatchMode/CreateBatchMode")
    ),
  },
  {
    key: "automationDashboard",
    title: "Automation",
    path: `${APP_PREFIX_PATH}/vudio/automation/dashboard`,
    component: React.lazy(() =>
      import("views/app-views/vudio/automation-dashboard")
    ),
  },
  {
    key: "createPost",
    title: "Create Post",
    path: `${APP_PREFIX_PATH}/posts/create`,
    component: React.lazy(() => import("views/app-views/vudio/CreatePost")),
  },
  {
    key: "publish.webApp.widget",
    title: "Widgets",
    path: `${APP_PREFIX_PATH}/web&App/widgets`,
    component: React.lazy(() =>
      import("views/app-views/vudio/web-and-app/widgets-dashboard")
    ),
  },
  {
    key: "publish.webApp.widget.create",
    title: "Widgets",
    path: `${APP_PREFIX_PATH}/web&App/widgets/create`,
    component: React.lazy(() =>
      import(
        "views/app-views/vudio/web-and-app/widgets-dashboard/components/createWidget"
      )
    ),
  },
  {
    key: "publish.webApp.videoLibrary",
    title: "Video Library",
    path: `${APP_PREFIX_PATH}/web&App/videoLibrary`,
    component: React.lazy(() =>
      import("views/app-views/vudio/web-and-app/video-library-dashboard")
    ),
  },
  {
    key: "publish.webApp.productLibrary",
    title: "Product Library",
    path: `${APP_PREFIX_PATH}/web&App/productLibrary`,
    component: React.lazy(() =>
      import("views/app-views/vudio/web-and-app/product-library-dashboard")
    ),
  },
  {
    key: "publish.webApp.collectionLibrary",
    title: "Collection Library",
    path: `${APP_PREFIX_PATH}/web&App/collectionLibrary`,
    component: React.lazy(() =>
      import("views/app-views/vudio/web-and-app/collection-library-dashboard")
    ),
  },
  {
    key: "publish.webApp.customLinkLibrary",
    title: "Custom Link Library",
    path: `${APP_PREFIX_PATH}/web&App/customLinkLibrary`,
    component: React.lazy(() =>
      import("views/app-views/vudio/web-and-app/custom-link-dashboard")
    ),
  },
  {
    key: "publish.webApp.pollLibrary",
    title: "Polls Library",
    path: `${APP_PREFIX_PATH}/web&App/pollLibrary`,
    component: React.lazy(() =>
      import("views/app-views/vudio/web-and-app/poll-library-dashboard")
    ),
  },
  {
    key: "publish.webApp.quizLibrary",
    title: "Quiz Library",
    path: `${APP_PREFIX_PATH}/web&App/quizLibrary`,
    component: React.lazy(() =>
      import("views/app-views/vudio/web-and-app/quiz-library-dashboard")
    ),
  },
  {
    key: "publish.webApp.formLibrary",
    title: "Forms Library",
    path: `${APP_PREFIX_PATH}/web&App/formLibrary`,
    component: React.lazy(() =>
      import("views/app-views/vudio/web-and-app/form-library-dashboard")
    ),
  },
  {
    key: "publish.webApp.storyLibrary",
    title: "Story Library",
    path: `${APP_PREFIX_PATH}/web&App/storyLibrary`,
    component: React.lazy(() =>
      import("views/app-views/vudio/web-and-app/story-library-dashboard")
    ),
  },
  {
    key: "publish.webApp.storyLibrary.create",
    title: "Create Story",
    path: `${APP_PREFIX_PATH}/web&App/storyLibrary/createStory`,
    component: React.lazy(() =>
      import(
        "views/app-views/vudio/web-and-app/story-library-dashboard/CreateStory"
      )
    ),
  },
  {
    key: "publish.webApp.analytics",
    title: "Analytics",
    path: `${APP_PREFIX_PATH}/web&App/analytics`,
    component: React.lazy(() =>
      import("views/app-views/vudio/web-and-app/analytics-dashboard")
    ),
  },

  {
    key: "publish.webApp.analytics",
    title: "Analytics",
    path: `${APP_PREFIX_PATH}/web&App/analytics/configureSteps`,
    component: React.lazy(() =>
      import(
        "views/app-views/vudio/web-and-app/analytics-dashboard/ConfigureSteps"
      )
    ),
  },

  {
    key: "createAutomation",
    title: "Automation",
    path: `${APP_PREFIX_PATH}/vudio/automation/create`,
    component: React.lazy(() =>
      import("views/app-views/vudio/CreateAutomation")
    ),
  },

  {
    key: "analytics.automation",
    title: "Analytics",
    path: `${APP_PREFIX_PATH}/web&App/analytics/automation`,
    component: React.lazy(() =>
      import(
        "views/app-views/vudio/web-and-app/analytics-dashboard/AutomationAnalytics"
      )
    ),
  },

  {
    key: "analytics.social",
    title: "Analytics",
    path: `${APP_PREFIX_PATH}/analytics/socialMedia`,
    component: React.lazy(() =>
      import(
        "views/app-views/vudio/web-and-app/analytics-dashboard/SocialMediaAnalytics"
      )
    ),
  },
  // {
  //   key: "analytics.livestream",
  //   title: "Analytics",
  //   path: `${APP_PREFIX_PATH}/analytics/livestream`,
  //   component: React.lazy(() =>
  //     import(
  //       "views/app-views/vudio/web-and-app/analytics-dashboard/LiveStreamAnalytics"
  //     )
  //   ),
  // },
  {
    key: "analytics.livestream.summary",
    title: "Analytics",
    path: `${APP_PREFIX_PATH}/analytics/livestream-summary`,
    component: React.lazy(() =>
      import(
        "views/app-views/vudio/web-and-app/analytics-dashboard/LivestreamSummary"
      )
    ),
  },
  {
    key: "analytics.vton.summary",
    title: "Analytics",
    path: `${APP_PREFIX_PATH}/analytics/vton-summary`,
    component: React.lazy(() =>
      import(
        "views/app-views/vudio/web-and-app/analytics-dashboard/VirtualTryonSummary"
      )
    ),
  },
  {
    key: "analytics.aiVideos.summary",
    title: "Analytics",
    path: `${APP_PREFIX_PATH}/analytics/ai-videos-summary`,
    component: React.lazy(() =>
      import(
        "views/app-views/vudio/web-and-app/analytics-dashboard/AIVideosSummary"
      )
    ),
  },
  {
    key: "studio_ai.home",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/home`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/StudioHome/V2")
    ),
  },
  {
    key: "studio_ai.library",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/home`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/StudioLibrary")
    ),
  },
  {
    key: "studio_ai.url_to_video",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/urlTovideo`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/URL_TO_VIDEO")
    ),
  },
  {
    key: "studio_ai.url_to_ai",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/urlToAi`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/URL_TO_AI_AVATAR")
    ),
  },
  {
    key: "studio_ai.image_to_video",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/aiVideoShoot`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AI_Video_Shoots/V2")
    ),
  },
  {
    key: "studio_ai.image_to_video",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/aiVideoEditor`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AI_Video_Shoots/V2")
    ),
  },
  {
    key: "studio_ai.batchMode",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/batchMode/home`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/BatchMode/BatchModeHome")
    ),
  },
  {
    key: "studio_ai.batchMode",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/batchMode/create`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/BatchMode/CreateBatchMode")
    ),
  },
  {
    key: "studio_ai.cinematicVideoShoot",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/cinematicVideo`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/CinematicVideoShoots")
    ),
  },
  {
    key: "studio_ai.aiPhotoshoot",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/aiCatalogue`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AICatalogue/Dashboard")
    ),
  },
  {
    key: "studio_ai.aiFaceSwap",
    title: "AI Face Swap",
    path: `${APP_PREFIX_PATH}/studioAI/aiFaceSwap`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AI_Face_Swap")
  ),
},
{
    key: "studio_ai.aiGraphics",
    title: "AI Face Swap",
    path: `${APP_PREFIX_PATH}/studioAI/aiGraphics`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AI_Graphics")
  ),
},
{
    key: "studio_ai.aiImageTemplate",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/aiImageTemplate`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AiImageTemplate")
    ),
  },
  {
    key: "studio_ai.virtualTryon",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/virtualTryon`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/VirtualTryon")
    ),
  },
  {
    key: "studio_ai.virtualTryonDetails",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/vton-job-details`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AICatalogue/VtonDetailsDashboard")
    ),
  },
  {
    key: "studio_ai.virtualTryonBulkUpload",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/virtualTryon/vtonBulkUpload`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AI_Photoshoot/VtonBulkUploadPage")
    ),
  },
  {
    key: "studio_ai.aiImageTemplate",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/aiImageTemplate/objectReplacer`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AiImageTemplate/ObjectReplacer")
    ),
  },
  {
    key: "studio_ai.aiTextToImage",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/aiTextToImage`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AI_Text_To_Image")
    ),
  },
  {
    key: "studio_ai.aiImageTemplate",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/aiImageTemplate/backgroundReplacer`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AiImageTemplate/BackgroundReplacer")
    ),
  },
  {
    key: "studio_ai.brandKit",
    title: "Brand Kit",
    path: `${APP_PREFIX_PATH}/studioAI/brandKit`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/BrandKit")
    ),
  },
  {
    key: "studio_ai.aiImageTemplate",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/aiImageTemplate/backgroundRemover`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AiImageTemplate/BackgroundRemover")
    ),
  },
  {
    key: "studio_ai.aiPhotoshootv3",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/aiImageTemplate/aiPhotoshootV3`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AI_Photoshoot/AI_Photoshoot_V4")
    ),
  },
    {
    key: "studio_ai.campaignAgent",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/ai-agents/campaignAgent`,
    component: React.lazy(() =>
      import("views/app-views/vudio/AIAgentsV2/CampaignAgent")
    ),
  },
  {
    key: "studio_ai.sageAgent",
    title: "Sage Agent",
    path: `${APP_PREFIX_PATH}/studioAI/ai-agents/sageAgent`,
    component: React.lazy(() =>
      import("views/app-views/vudio/AIAgentsV2/SageAgent")
    ),
  },
  {
    key: "studio_ai.rexAgent",
    title: "Rex Agent",
    path: `${APP_PREFIX_PATH}/studioAI/ai-agents/rexAgent`,
    component: React.lazy(() =>
      import("views/app-views/vudio/AIAgentsV2/RexAgent/RexIntroPage")
    ),
  },
  {
    key: "studio_ai.emailAgent",
    title: "Rex Agent",
    path: `${APP_PREFIX_PATH}/studioAI/ai-agents/emailAgent`,
    component: React.lazy(() =>
      import("views/app-views/vudio/AIAgentsV2/RexAgent")
    ),
  },
  {
    key: "studio_ai.campaignDetails",
    title: "Campaign Details",
    path: `${APP_PREFIX_PATH}/studioAI/ai-agents/campaignDetails/:campaignId`,
    component: React.lazy(() =>
      import("views/app-views/vudio/AIAgentsV2/CampaignAgent/CampaignContentResults")
    ),
  },
  
  {
    key: "studio_ai.aiImageTemplate",
    title: "AI Studio",
    path: `${APP_PREFIX_PATH}/studioAI/aiImageEditor`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/AI_Image_Editor")
    ),
  },
  // {
  //   key: "livestream.home",
  //   title: "LiveStream",
  //   path: `${APP_PREFIX_PATH}/livestream/home`,
  //   component: React.lazy(() => import("views/app-views/vudio/LiveStream")),
  // },
  // {
  //   key: "livestream.home",
  //   title: "LiveStream",
  //   path: `${APP_PREFIX_PATH}/livestream/create`,
  //   component: React.lazy(() =>
  //     import("views/app-views/vudio/LiveStream/Create_LiveStream")
  //   ),
  // },
  {
    key: "accountSettingsDashboard",
    title: "Account Settings",
    path: `${APP_PREFIX_PATH}/vudio/generalSettings/accountSettings`,
    component: React.lazy(() =>
      import("views/app-views/vudio/accout-settings-dashboard")
    ),
  },
  {
    key: "usersandPermissions",
    title: "Users and Permissions",

    path: `${APP_PREFIX_PATH}/vudio/generalSettings/usersPermissions`,
    component: React.lazy(() =>
      import("views/app-views/vudio/users-permissions-dashboard")
    ),
  },
  {
    key: "generalSettingsStores",
    title: "Stores",

    path: `${APP_PREFIX_PATH}/generalSettings/stores`,
    component: React.lazy(() =>
      import("views/app-views/vudio/stores")
    ),
  },
  {
    key: "accountSetting.WebAppWidget",
    title: "Web/ App Widgets",
    path: `${APP_PREFIX_PATH}/vudio/generalSettings/webAppWidgets`,
    component: React.lazy(() =>
      import("views/app-views/vudio/accout-settings-dashboard/Web-App Widget")
    ),
  },
  {
    key: "accountSetting.livestream",
    title: "LiveStream",
    path: `${APP_PREFIX_PATH}/vudio/generalSettings/livestream`,
    component: React.lazy(() =>
      import("views/app-views/vudio/accout-settings-dashboard/LiveStream")
    ),
  },
  {
    key: "accountSetting.one2one",
    title: "LiveStream",
    path: `${APP_PREFIX_PATH}/vudio/generalSettings/oneToone`,
    component: React.lazy(() =>
      import("views/app-views/vudio/accout-settings-dashboard/one-to-one")
    ),
  },
  {
    key: "accountSetting.childCompanies",
    title: "Child Companies",
    path: `${APP_PREFIX_PATH}/vudio/generalSettings/childCompanies`,
    component: React.lazy(() =>
      import("views/app-views/vudio/accout-settings-dashboard/ChildCompanies")
    ),
  },
  {
    key: "accountSetting.instantCallConfiguration",
    title: "Child Companies",
    path: `${APP_PREFIX_PATH}/vudio/generalSettings/instantCallConfiguration`,
    component: React.lazy(() =>
      import("views/app-views/vudio/accout-settings-dashboard/instant-call-configuartion")
    ),
  },
  {
    key: "accountSetting.shoppingAssistantConfiguration",
    title: "Child Companies",
    path: `${APP_PREFIX_PATH}/vudio/generalSettings/shoppingAssistantConfiguration`,
    component: React.lazy(() =>
      import("views/app-views/vudio/accout-settings-dashboard/shopping-assistant-configuration")
    ),
  },
  // {
  //   key: "videoCallPluginCustomization",
  //   title: "Plugin Customization",
  //   path: `${APP_PREFIX_PATH}/generalSettings/video-call-plugin-customization`,
  //   component: React.lazy(() =>
  //     import("views/app-views/vudio/video-call-plugin-customization")
  //   ),
  // },

  {
    key: "connectAccount",
    title: "Connect Account",
    path: `${APP_PREFIX_PATH}/generalSettings/connect-account`,
    component: React.lazy(() =>
      import("views/app-views/vudio/connect-account")
    ),
  },

    {
    key: "whatsappTemplates",
    title: "WhatsApp",
    path: `${APP_PREFIX_PATH}/generalSettings/whatsapp-templates`,
    component: React.lazy(() =>
      import("views/app-views/vudio/whatsapp-templates")
    ),
  },
  {
    key: "accountSetting.storeConfiguration",
    title: "LiveStream",
    path: `${APP_PREFIX_PATH}/vudio/generalSettings/storeConfigure`,
    component: React.lazy(() =>
      import(
        "views/app-views/vudio/accout-settings-dashboard/Store_Configuration"
      )
    ),
  },
  // {
  //   key: "live-call.live-call",
  //   path: `${APP_PREFIX_PATH}/live-call/live-call`,
  //   component: React.lazy(() => import("views/app-views/live-call/livecall")),
  // },
  // {
  //   key: "live-stream.stream",
  //   path: `${APP_PREFIX_PATH}/live-call/stream`,
  //   component: React.lazy(() =>
  //     import("views/app-views/one-to-many/LiveStreamView")
  //   ),
  // },

  // {
  //   key: "one-to-one.analytics",
  //   path: `${APP_PREFIX_PATH}/one-to-one/analytics`,
  //   component: React.lazy(() =>
  //     import("views/app-views/one-to-one/analytics-report")
  //   ),
  // },
    {
    key: "one-to-one.active-agents",
    path: `${APP_PREFIX_PATH}/one-to-one/active-agents`,
    component: React.lazy(() =>
      import("views/app-views/one-to-one/active-agents")
    ),
  },
  {
    key: "one-to-one.call-schedule",
    path: `${APP_PREFIX_PATH}/one-to-one/call-schedule`,
    component: React.lazy(() =>
      import("views/app-views/one-to-one/call-schedule")
    ),
  },
  {
    key: "one-to-one.ongoing-call",
    path: `${APP_PREFIX_PATH}/one-to-one/ongoing-call`,
    component: React.lazy(() =>
      import("views/app-views/one-to-one/ongoing-call")
    ),
  },
  {
    key: "one-to-one.call-history",
    path: `${APP_PREFIX_PATH}/one-to-one/call-history`,
    component: React.lazy(() =>
      import("views/app-views/one-to-one/call-history")
    ),
  },
  {
    key: "one-to-one.analytics",
    path: `${APP_PREFIX_PATH}/one-to-one/analytics`,
    component: React.lazy(() =>
      import("views/app-views/one-to-one/analytics")
    ),
  },
  {
    key: "one-to-one.faqs-queries",
    path: `${APP_PREFIX_PATH}/one-to-one/faqs-queries`,
    component: React.lazy(() =>
      import("views/app-views/one-to-one/faqs-and-queries")
    ),
  },
  {
    key: "one-to-one.customization",
    path: `${APP_PREFIX_PATH}/one-to-one/customization`,
    component: React.lazy(() =>
      import("views/app-views/one-to-one/customization")
    ),
  },

  {
    key: "subscription-plan",
    path: `${APP_PREFIX_PATH}/vudio/subscription/plan`,
    component: React.lazy(() => import("views/app-views/vudio/billing")),
  },
  {
    key: "verify-plan",
    path: `${APP_PREFIX_PATH}/subscription/verify`,
    component: React.lazy(() =>
      import("views/app-views/shopify-plans/VerifyToken.js")
    ),
  },
  {
    key: "creditHistory",
    path: `${APP_PREFIX_PATH}/vudio/creditHistory`,
    component: React.lazy(() =>
      import("views/app-views/vudio/StudioAI/CreditHistory")
    ),
  },
  {
    key: "adminPlans",
    path: `${APP_PREFIX_PATH}/admin/plans`,
    component: React.lazy(() => import("views/app-views/vudio/AdminPlan")),
  },
  {
    key: "adminApiSwitch",
    path: `${APP_PREFIX_PATH}/admin/apiSwitch`,
    component: React.lazy(() => import("views/app-views/vudio/AdminAISwitch")),
  },
  {
    key: "adminBrandListing",
    path: `${APP_PREFIX_PATH}/admin/brandListing`,
    component: React.lazy(() =>
      import("views/app-views/vudio/AdminBrandListing")
    ),
  },
  {
    key: "adminAPICredits",
    path: `${APP_PREFIX_PATH}/admin/apiCredits`,
    component: React.lazy(() =>
      import("views/app-views/vudio/AdminAPICredits")
    ),
  },

  {
    key: "ai-agents",
    path: `${APP_PREFIX_PATH}/ai-agents`,
    component: React.lazy(() => import("views/app-views/vudio/AIAgentsV2")),
  },
  {
    key: "gemini-test-dashboard",
    path: `${APP_PREFIX_PATH}/admin/gemini-test-dashboard`,
    component: React.lazy(() =>
      import("views/app-views/vudio/admin-specific-views/gemini-test-dashboard")
    ),
  },
  {
    key: "vton-categories-dashboard",
    path: `${APP_PREFIX_PATH}/admin/vton-categories-dashboard`,
    component: React.lazy(() =>
      import(
        "views/app-views/vudio/admin-specific-views/vton-category-management"
      )
    ),
  },
  {
    key: "background-management",
    path: `${APP_PREFIX_PATH}/admin/background-management`,
    component: React.lazy(() =>
      import(
        "views/app-views/vudio/admin-specific-views/background-management"
      )
    ),
  },
   {
    key: "prompt-dahboard",
    path: `${APP_PREFIX_PATH}/admin/prompt-dashboard`,
    component: React.lazy(() =>
      import(
        "views/app-views/vudio/admin-specific-views/prompt-dahboard"
      )
    ),
  },
  {
    key: "under-development",
    path: `${APP_PREFIX_PATH}/coming-soon`,
    component: React.lazy(() =>
      import("views/app-views/vudio/under-development")
    ),
  },
  {
    key: "tutorial",
    path: `${APP_PREFIX_PATH}/tutorial`,
    component: React.lazy(() => import("views/app-views/vudio/tutorial")),
  },
  {
    key: "content-library",
    path: `${APP_PREFIX_PATH}/content-library`,
    component: React.lazy(() =>
      import("views/app-views/vudio/content-library")
  ),
},
  {
    key: "spaces",
    path: `${APP_PREFIX_PATH}/spaces`,
    component: React.lazy(() =>
      import("views/app-views/vudio/VudioSpaces")
    ),
  },
    {
    key: "appstore",
    path: `${APP_PREFIX_PATH}/appstore`,
    component: React.lazy(() => import("views/app-views/vudio/AppStore")),
  },
  {
    key: "ai-ads",
    path: `${APP_PREFIX_PATH}/ai-ads`,
    component: React.lazy(() => import("views/app-views/vudio/AIAds")),
  },
  {
    key: "ai-ads-creation",
    path: `${APP_PREFIX_PATH}/ai-ads/creation`,
    component: React.lazy(() => import("views/app-views/vudio/AIAds/create")),
  },
  {
    key: "video-prompt",
    path: `${APP_PREFIX_PATH}/video-prompt`,
    component: React.lazy(() =>
      import("views/app-views/vudio/video-prompts")
    ),
  },
  {
    key: "accountSetting.userAndPermissions",
    title: "User & Permissions",
    path: `${APP_PREFIX_PATH}/vudio/user-and-permissions`,
    component: React.lazy(() =>
      import("views/app-views/vudio/users-and-permissions")
    ),
  },
  {
    key: "ai-automation",
    title: "AI Workflow",
    path: `${APP_PREFIX_PATH}/ai-automation`,
    component: React.lazy(() =>
      import("views/app-views/vudio/automation")
    ),
  },
  {
    key: "ai-automation-create",
    title: "AI Workflow Create",
    path: `${APP_PREFIX_PATH}/ai-automation/create`,
    component: React.lazy(() =>
      import("views/app-views/vudio/automation/creation")
    ),
  },
  {
    key: "template-management",
    title: "Template Mnagement",
    path: `${APP_PREFIX_PATH}/admin/template-management`,
    component: React.lazy(() =>
      import("views/app-views/vudio/admin-specific-views/template-management")
    ),
  },
  {
    key: "campaigns",
    title: "Campaigns",
    path: `${APP_PREFIX_PATH}/campaigns`,
    component: React.lazy(() =>
      import("views/app-views/vudio/campaigns")
    ),
  },

  {
    key: "campaigns-whatsapp-account-details",
    title: "WhatsApp Account Details",
    path: `${APP_PREFIX_PATH}/campaigns/whatsapp-account-details`,
    component: React.lazy(() =>
      import("views/app-views/vudio/campaigns/account-details/whatsapp")
    ),
  },
   {
    key: "workflow-personalized-video-details",
    title: "Workflow Personalized Video Details",
    path: `${APP_PREFIX_PATH}/ai-autmation/workflow-personalized-video-details`,
    component: React.lazy(() =>
      import("views/app-views/vudio/automation/your-creation/personalized-video-details")
    ),
  },
   {
    key: "spaces",
    title: "Spaces",
    path: `${APP_PREFIX_PATH}/spaces`,
    component: React.lazy(() =>
      import("views/app-views/vudio/spaces")
    ),
  },
  {
    key: "companies",
    title: "Companies",
    path: `${APP_PREFIX_PATH}/vudio/generalSettings/companies`,
    component: React.lazy(() =>
      import("views/app-views/vudio/accout-settings-dashboard/companies")
    ),
  },
  {
    key: "all-users",
    title: "All Users",
    path: `${APP_PREFIX_PATH}/vudio/generalSettings/allUsers`,
    component: React.lazy(() =>
      import("views/app-views/vudio/accout-settings-dashboard/all-users")
    ),
  },
    {
    key: "webhooks",
    title: "Webhooks",
    path: `${APP_PREFIX_PATH}/vudio/generalSettings/webhooks`,
    component: React.lazy(() =>
      import("views/app-views/vudio/accout-settings-dashboard/webhooks")
    ),
  },

   {
    key: "ai-assistant-chat-history",
    title: "Chat History",
    path: `${APP_PREFIX_PATH}/ai-assistant/chat-history`,
    component: React.lazy(() =>
      import("views/app-views/ai-assistant/chat-histoty")
    ),
  },
    {
    key: "ai-assistant-products",
    title: "Products",
    path: `${APP_PREFIX_PATH}/ai-assistant/products`,
    component: React.lazy(() =>
      import("views/app-views/ai-assistant/products")
    ),
  },
  {
    key: "ai-assistant-configuration",
    title: "Configuration",
    path: `${APP_PREFIX_PATH}/ai-assistant/configuration`,
    component: React.lazy(() =>
      import("views/app-views/ai-assistant/configuration")
    ),
  },
  {
    key: "ai-assistant-analytics",
    title: "Analytics",
    path: `${APP_PREFIX_PATH}/ai-assistant/analytics`,
    component: React.lazy(() =>
      import("views/app-views/ai-assistant/analytics")
    ),
  },
  {
    key: "shoppable-feed-new-videos",
    title: "Shoppable Feed",
    path: `${APP_PREFIX_PATH}/shoppable-feed/videos`,
    component: React.lazy(() =>
      import("views/app-views/shoppbale-feed-new")
    ),
  },
    {
    key: "shoppable-feed-new-playlist",
    title: "Playlist",
    path: `${APP_PREFIX_PATH}/shoppable-feed/playlist`,
    component: React.lazy(() =>
      import("views/app-views/shoppbale-feed-new/playlist")
    ),
  },
    {
    key: "shoppable-feed-new-theme",
    title: "Theme",
    path: `${APP_PREFIX_PATH}/shoppable-feed/themes`,
    component: React.lazy(() =>
      import("views/app-views/shoppbale-feed-new/themes")
    ),
  },
    {
    key: "shoppable-feed-new-story-list",
    title: "Story",
    path: `${APP_PREFIX_PATH}/shoppable-feed/story`,
    component: React.lazy(() => import("views/app-views/story-new")),
  },
    {
    key: "shoppable-feed-new-story-collection",
    title: "Story Collection",
    path: `${APP_PREFIX_PATH}/shoppable-feed/story-collection`,
    component: React.lazy(() => import("views/app-views/story-new/collection")),
  },
];

export const protectedRoutes = isVudioDomain ? vudio_routes : [];

export const getTitleForCurrentPath = () => {
  const pathname = window.location.pathname;

  const matchedRoute = vudio_routes.find((route) => route.path == pathname);

  return matchedRoute ? matchedRoute?.title : "Default Title";
};
